import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/bff/client';

import InternalLink from './InternalLink';
import getCityUrl from './getCityUrl';

const OtherCitiesLinks = ({ cities }) => {
  const renderCities = () =>
    cities.map((city, index) => (
      <InternalLink
        key={city}
        url={getCityUrl(city)}
        text={trans(`city.${city}`)}
        hasComma={index + 1 < cities.length}
      />
    ));

  return <div>{renderCities()}.</div>;
};

OtherCitiesLinks.propTypes = {
  cities: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default OtherCitiesLinks;
